import { IconButton, Tooltip, Typography } from "@mui/material";
import {
  Datagrid,
  DateField,
  DateInput,
  downloadCSV,
  List,
  TextField,
  TextInput,
  TopToolbar,
  useListContext,
  usePermissions,
  useRecordContext,
  useRefresh,
} from "react-admin";
import ApplicationLinkApplicationIdField from "../../applications/ApplicationLinkApplicationIdField";
import CustomerIdLinkUserIdField from "../../customers/CustomerIdLinkUserIdField";
import LoanNumLinkField from "../../loans/LoanNumLinkField";
import CustomAmountField from "../../unit/CustomAmountField";
import CustomCancelTaskIcon from "../../unit/CustomCancelTaskIcon";
import CustomDateField from "../../unit/CustomDateField";
import CustomExportButton from "../../unit/CustomExportButton";
import CustomFilterButton from "../../unit/CustomFilterButton";
import PostPagination from "../../unit/PostPagination";
import useNotify from "../../unit/useNotify";
import AchPaymentsAside from "./AchPaymentsAside";
import AchPaymentsFilters from "./AchPaymentsFilters";
import { hmLightTheme } from "../../themes/hmTheme";
import sendRequest from "../../dataProvider/sendRequest";
import ReceiptIcon from "@mui/icons-material/Receipt";
import AchPaymentsDetail from "./AchPaymentsDetail";
import ExceptionManualProcessed from "./ExceptionManualProcessed";
import CustomLoading from "../../unit/CustomLoading";
import { useState } from "react";
import FilterAmount from "../../unit/FilterAmount";
import FilterAchMethod from "../../unit/FilterAchMethod";
import FilterErrorCode from "../../unit/FilterErrorCode";
import formatDate from "../../unit/formatDate";
import getFiltersFromURL from "../../unit/getFiltersFromURL";
import HmLoading from "../../unit/HmLoading";
import NoResults from "../../unit/NoResults";
import NoPermission from "../../unit/NoPermission";
const AchPaymentsListActions = () => {
  const { total } = useListContext();
  const { permissions } = usePermissions();
  const listContext = useListContext();
  const { filterValues } = listContext;

  return (
    <TopToolbar sx={{ width: "100%" }}>
      <CustomFilterButton />
      <CustomExportButton />
    </TopToolbar>
  );
};
function getErrorMsg(errormsg: string) {
  const rawErrorMsg = String(errormsg || "");
  const rawLower = rawErrorMsg.toLowerCase();

  // Keep a normalized value for backward-compatible checks.
  let normalized = rawErrorMsg;
  if (normalized == "No Source FundingSource Found.") {
    normalized = "No Funding Source";
  }
  if (
    normalized?.includes("checkSkipPayment: account") &&
    normalized?.includes("balance") &&
    normalized?.includes("is not enough for payment")
  ) {
    normalized = "Balance";
  }
  const normalizedLower = normalized.toLowerCase();

  const rCodeMatch = normalized.match(/R0\d{1}|R1\d{1}|R2\d{1}/i);
  if (rCodeMatch) {
    return rCodeMatch[0].toUpperCase();
  }
  if (
    rawLower.includes("more than(equal) 2 failed") ||
    rawLower.includes("failed checking balance before due date")
  ) {
    return "ACH Paused";
  }
  if (
    rawLower.includes("checkskippayment: account") ||
    rawLower.includes("is not enough for payment") ||
    normalizedLower.includes("balance")
  ) {
    // return "Balance Error";
    return "Balance Low";
  }
  if (
    rawLower.includes("account or customer restricted") ||
    rawLower.includes("invalid destination funding source") ||
    rawLower.includes("invalid funding source") ||
    rawLower.includes("receiver restricted") ||
    rawLower.includes("sender restricted") ||
    rawLower.includes("no source fundingsource found") ||
    rawLower.includes("no target fundingsource found") ||
    normalizedLower.includes("account restricted") ||
    normalizedLower.includes("invalid destination source") ||
    normalizedLower.includes("invalid funding source")
  ) {
    return "Account Error";
  }
  if (
    rawLower.includes("insufficient funds") ||
    normalizedLower.includes("insufficient funds")
  ) {
    return "Insufficent";
  }
  if (
    rawLower.includes("a transfer task exists already") ||
    rawLower.includes("transfer task exists") ||
    rawLower.includes("invalid amount") ||
    normalizedLower.includes("task exists") ||
    normalizedLower.includes("invalid amount")
  ) {
    return "Transfer Error";
  }

  if (
    rawLower.includes("the request body contains bad syntax or is incomplete")
  ) {
    return "Code Error";
  }

  return "No results found";
}
const CustomErrorMsg = ({ ...props }: any) => {
  const record = useRecordContext();
  if (!record) return null;
  if (record?.sStatus == "cancelled") {
    return <Typography color="error">Cancelled</Typography>;
  }
  const errormsgNew = getErrorMsg(record?.sErrorMsg || "");
  return <Typography>{errormsgNew}</Typography>;
};
const CustomAccountNumberLast4NumberField = ({
  source,
  label,
  ...props
}: any) => {
  const record = useRecordContext();
  if (!record) return null;
  const accountNumber = record[source];
  if (accountNumber && accountNumber.length >= 4) {
    return (
      <Typography
        title={accountNumber} // Show full account number on hover
      >
        ***{accountNumber.slice(-4)} {/* Display only the last 4 digits */}
      </Typography>
    );
  }
  return <Typography>***{accountNumber ? accountNumber : ""}</Typography>;
};

const total: any = [];

const customACHNewExporter = (records: any) => {
  let filterStatus = "";
  if (records.length > 0) {
    filterStatus = records[0].sStatus;
  }
  let data = [];
  let title = {};

  const currentFilters = getFiltersFromURL();
  const filter_status = currentFilters?.status;
  const filter_curStatus = currentFilters?.curStatus;
  console.log("filter_status===>", filter_status);
  if (
    filter_status == "repayment_past30unableInitiate" ||
    filter_status == "repayment_past30initiatedButFailed" ||
    filter_status == "disbursement_past30failed"
  ) {
    data = records.map((record: any) => {
      const {
        id,
        dAmount,
        iApplicationId,
        sLoanNum,
        iUserId,
        sOwner,
        scheduled,
        dCreatedDate,
        sErrorMsg,
        dErrorDate,
      } = record;
      return {
        id,
        dAmount,
        iApplicationId,
        sLoanNum,
        iUserId,
        sOwner: getMetholdTitle(sOwner),
        scheduled: formatDate(scheduled),
        dCreatedDate: formatDate(dCreatedDate),
        sErrorMsg: getErrorMsg(sErrorMsg),
        dErrorDate: formatDate(dErrorDate),
      };
    });
    title = {
      id: "Transfer #",
      dAmount: "Amount",
      iApplicationId: "App #",
      sLoanNum: "Loan #",
      iUserId: "User #",
      sOwner: "Method",
      scheduled: "Date Scheduled",
      dCreatedDate: "Date Initiated",
      sErrorMsg: "Error Code",
      dErrorDate: "Date Failed",
    };
  } else if (filter_status == "disbursement_past30processedAndProcessing") {
    data = records.map((record: any) => {
      const {
        id,
        dAmount,
        iApplicationId,
        sLoanNum,
        iUserId,
        sOwner,
        scheduled,
        dCreatedDate,
        dDateCompleted,
      } = record;
      return {
        id,
        dAmount,
        iApplicationId,
        sLoanNum,
        iUserId,
        sOwner: getMetholdTitle(sOwner),
        scheduled: formatDate(scheduled),
        dCreatedDate: formatDate(dCreatedDate),
        dDateCompleted: formatDate(dDateCompleted),
      };
    });
    title = {
      id: "Transfer #",
      dAmount: "Amount",
      iApplicationId: "App #",
      sLoanNum: "Loan #",
      iUserId: "User #",
      sOwner: "Method",
      scheduled: "Date Scheduled",
      dCreatedDate: "Date Initiated",
      dDateCompleted: "Date Completed",
    };
  } else if (
    filter_status == "disbursement_delayed_fails" ||
    filter_status == "refund_today" ||
    filter_status == "refund_prepareForProcessing" ||
    filter_status == "refund_past180processed" ||
    filter_status == "refund_past180failed"
  ) {
    data = records.map((record: any) => {
      const {
        id,
        dAmount,
        iApplicationId,
        sLoanNum,
        iUserId,
        scheduled,
        dCreatedDate,
      } = record;
      return {
        id,
        dAmount,
        iApplicationId,
        sLoanNum,
        iUserId,
        scheduled: formatDate(scheduled),
        dCreatedDate: formatDate(dCreatedDate),
      };
    });
    title = {
      id: "Transfer #",
      dAmount: "Amount",
      iApplicationId: "App #",
      sLoanNum: "Loan #",
      iUserId: "User #",
      scheduled: "Date Scheduled",
      dCreatedDate: "Date Initiated",
    };
  } else if (
    filter_status == "repayment_prepareForProcessing" ||
    filter_status == "repayment_today" ||
    filter_status == "disbursement_prepareForProcessing" ||
    filter_status == "disbursement_today"
  ) {
    data = records.map((record: any) => {
      const {
        id,
        dAmount,
        iApplicationId,
        sLoanNum,
        iUserId,
        sOwner,
        scheduled,
        dCreatedDate,
      } = record;
      return {
        id,
        dAmount,
        iApplicationId,
        sLoanNum,
        iUserId,
        sOwner: getMetholdTitle(sOwner),
        scheduled: formatDate(scheduled),
        dCreatedDate: formatDate(dCreatedDate),
      };
    });
    title = {
      id: "Transfer #",
      dAmount: "Amount",
      iApplicationId: "App #",
      sLoanNum: "Loan #",
      iUserId: "User #",
      sOwner: "Method",
      scheduled: "Date Scheduled",
      dCreatedDate: "Date Initiated",
    };
  } else if (
    filter_status == "repayment_next15daysScheduled" ||
    filter_status == "disbursement_next10daysScheduled"
  ) {
    data = records.map((record: any) => {
      const {
        id,
        dAmount,
        iApplicationId,
        sLoanNum,
        iUserId,
        sOwner,
        scheduled,
      } = record;
      return {
        id,
        dAmount,
        iApplicationId,
        sLoanNum,
        iUserId,
        sOwner: getMetholdTitle(sOwner),
        scheduled: formatDate(scheduled),
      };
    });
    title = {
      id: "Transfer #",
      dAmount: "Amount",
      iApplicationId: "App #",
      sLoanNum: "Loan #",
      iUserId: "User #",
      sOwner: "Method",
      scheduled: "Date Scheduled",
    };
  } else if (
    filter_status == "repayment_delayedFails" ||
    filter_status == "repayment_delayedCanceled"
  ) {
    data = records.map((record: any) => {
      const {
        id,
        sType,
        dAmount,
        iApplicationId,
        sLoanNum,
        iUserId,
        sOwner,
        dCreatedDate,
        sErrorMsg,
        dErrorDate,
      } = record;
      return {
        id,
        sType,
        dAmount,
        iApplicationId,
        sLoanNum,
        iUserId,
        sOwner: getMetholdTitle(sOwner),
        dCreatedDate: formatDate(dCreatedDate),
        sErrorMsg: getErrorMsg(sErrorMsg),
        dErrorDate: formatDate(dErrorDate),
      };
    });
    title = {
      id: "Transfer #",
      sType: "Type",
      dAmount: "Amount",
      iApplicationId: "App #",
      sLoanNum: "Loan #",
      iUserId: "User #",
      sOwner: "Method",
      dCreatedDate: "Date Initiated",
      sErrorMsg: "Error Code",
      dErrorDate: "Date Failed",
    };
  } else {
    data = records.map((record: any) => {
      const { id, dAmount, iApplicationId, sLoanNum, iUserId } = record;
      return {
        id,
        dAmount,
        iApplicationId,
        sLoanNum,
        iUserId,
      };
    });
    title = {
      id: "Transfer #",
      dAmount: "Amount",
      iApplicationId: "App #",
      sLoanNum: "Loan #",
      iUserId: "User #",
    };
  }

  return {
    title: title,
    data: data,
    filterStatus: filterStatus,
  };
};
const customACHExporter = (records: any) => {
  const filterData = customACHNewExporter(records);

  let csvTitle = filterData.title;
  let data = filterData.data;
  let filterStatus = filterData.filterStatus;

  const currentFilters = getFiltersFromURL();
  const filter_status = currentFilters?.status;
  const filter_curStatus = currentFilters?.curStatus;
  const filter_filterRemainingterm = currentFilters?.filterRemainingterm;
  // console.log("currentFilters in exporter:", currentFilters);
  const otherFilters = { ...currentFilters };
  delete otherFilters.status;
  delete otherFilters.curStatus;
  delete otherFilters.filterRemainingterm;
  const filterString = Object.entries(otherFilters)
    .map(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        if (key == "id") {
          key = "Transfer #";
        }
        return `[${getFieldTitle(key)} ${getFieldValueType(
          key
        )} "${getFieldValue(key, value)}"]`;
      }
      return "";
    })
    .filter(Boolean)
    .join("");

  console.log("Filter string:", filterString);
  ///}}}

  const csvData = [{ ...csvTitle }, ...data];
  const csvDataStr = csvData.map((row) => Object.values(row).join(","));
  let filename = "";
  filename += customACHFilterText(filter_status, filter_curStatus);
  if (filterString) {
    csvDataStr.push("");
    csvDataStr.push("Filters Applied:" + filterString);
  }

  downloadCSV(csvDataStr.join("\n"), filename);
};

function getFieldTitle(field: string) {
  const titleMap = {
    product: "Product",
    userName: "Applicant Name",
    userEmail: "Applicant Email",
    coName: "Co-Applicant Name",
    guarantorName: "Guarantor Name",
    amountSubmit: "Amount Applied",
    amountReview: "Amount Offered",
    decision: "Decision",
    counselor: "Referring Counselor",
    employer: "Referring Employer",
    referralVerify: "Verification Status",
    appFees: "Application Fees Status",
    borrowerAgreement: "Borrower Agreement",
    sApplicationResponse: "Borrower Acceptance",
    //ach
    id: "App #",
    iUserId: "User #",
    sLoanNum: "Loan #",
    amount: "Amount",
    achMethod: "Method",
    errorCode: "Error Code",
    dDateScheduled: "Data Scheduled",
    dDateInitiated: "Data Initiated",
    dDateFailed: "Date Failed",
    dDateCompleted: "Date Completed",
  };
  return titleMap[field] || field;
}
function getFieldValueType(field: string) {
  const titleMap = {
    id: "contains",
    iUserId: "contains",
    sLoanNum: "contains",
    product: "is",
    userName: "contains",
    userEmail: "contains",
    coName: "contains",
    guarantorName: "contains",
    amountSubmit: "in",
    amountReview: "in",
    decision: "is",
    counselor: "contains",
    employer: "contains",
    referralVerify: "is",
    appFees: "is",
    borrowerAgreement: "is",
    sApplicationResponse: "is",
    amount: "in",
    achMethod: "is",
    errorCode: "is",
    dDateScheduled: "is",
    dDateInitiated: "is",
    dDateFailed: "is",
    dDateCompleted: "is",
  };
  return titleMap[field] || field;
}

function getFieldValue(field: string, value: any) {
  if (field == "amount") {
    if (value == "1") {
      return "<$20";
    } else if (value == "2") {
      return "$20-$50";
    } else if (value == "3") {
      return "$50-$100";
    } else if (value == "4") {
      return "$100-$200";
    } else if (value == "5") {
      return "$200-$500";
    } else if (value == "6") {
      return "$500-$1000";
    } else if (value == "7") {
      return ">$1000";
    }
  } else {
    return value;
  }
}

function customACHFilterText(filter_status: string, filter_curStatus: string) {
  let filterText = "";
  if (filter_status == "repayment_past30unableInitiate") {
    filterText += "Repayments_Past 30 Days Unable To Initiate";
  } else if (filter_status == "repayment_past30initiatedButFailed") {
    filterText += "Repayments_Past 30 Days Initiated But Failed";
  } else if (filter_status == "repayment_past30processed") {
    filterText += "Repayments_Past 30 Days Processed";
  } else if (filter_status == "repayment_prepareForProcessing") {
    filterText += "Repayments_Processing";
  } else if (filter_status == "repayment_today") {
    filterText += "Repayments_Schedule";
  } else if (filter_status == "repayment_next15daysScheduled") {
    filterText += "Repayments_Next 10 Days Scheduled";
  } else if (filter_status == "repayment_delayedFails") {
    filterText += "Repayments_Past 12 Months Delayed Fails";
  } else if (filter_status == "repayment_delayedCanceled") {
    filterText += "Repayments_Past 12 Months Delayed Canceled";
  } else if (filter_status == "disbursement_past30failed") {
    filterText += "Disbursements_Past 30 Days Failed";
  } else if (filter_status == "disbursement_past30processedAndProcessing") {
    filterText += "Disbursements_Past 30 Days Processed";
  } else if (filter_status == "disbursement_prepareForProcessing") {
    filterText += "Disbursements_Processing";
  } else if (filter_status == "disbursement_today") {
    filterText += "Disbursements_Schedule";
  } else if (filter_status == "disbursement_next10daysScheduled") {
    filterText += "Disbursements_Next 10 Days Scheduled";
  }
  return filterText;
}
const AchPaymentsList = () => {
  const permissions =
    localStorage.getItem("bbaccess")?.toString().split(",") || [];
  if (!permissions.includes("personal_ach_payments")) {
    return <NoPermission />;
  }
  const [achFilterData, setAchFilterData] = useState([
    <TextInput
      label="App #"
      source="iApplicationId"
      defaultValue=""
      variant="outlined"
    />,
    <TextInput
      label="Loan #"
      source="sLoanNum"
      defaultValue=""
      variant="outlined"
    />,
    <TextInput
      label="User #"
      source="userId"
      defaultValue=""
      variant="outlined"
    />,
    <FilterAmount source="amount" label="Amount" variant="outlined" />,
    <FilterAchMethod source="achMethod" label="Method" variant="outlined" />,
    <FilterErrorCode
      source="errorCode"
      label="Error Code"
      variant="outlined"
    />,
    <DateInput
      label="Date Scheduled"
      source="dDateScheduled"
      defaultValue=""
      variant="outlined"
    />,
    <DateInput
      label="Date Initiated"
      source="dDateInitiated"
      defaultValue=""
      variant="outlined"
    />,
    <DateInput
      label="Date Completed"
      source="dDateCompleted"
      defaultValue=""
      variant="outlined"
      disabled={true}
    />,
    <DateInput
      label="Date Failed"
      source="dDateFailed"
      defaultValue=""
      variant="outlined"
    />,
  ]);

  const handleFilterStatusChange = (newStatus: string) => {
    const AchPaymentsFilters = [
      <TextInput
        label="App #"
        source="iApplicationId"
        defaultValue=""
        variant="outlined"
      />,
      <TextInput
        label="Loan #"
        source="sLoanNum"
        defaultValue=""
        variant="outlined"
      />,
      <TextInput
        label="User #"
        source="userId"
        defaultValue=""
        variant="outlined"
      />,
      <FilterAmount source="amount" label="Amount" variant="outlined" />,
      <FilterAchMethod source="achMethod" label="Method" variant="outlined" />,
      <FilterErrorCode
        source="errorCode"
        label="Error Code"
        variant="outlined"
        disabled={
          newStatus == "repayment_past30unableInitiate" ||
          newStatus == "repayment_past30initiatedButFailed" ||
          newStatus == "repayment_delayedFails" ||
          newStatus == "repayment_delayedCanceled"
            ? false
            : true
        }
      />,
      <DateInput
        label="Date Scheduled"
        source="dDateScheduled"
        defaultValue=""
        variant="outlined"
      />,
      <DateInput
        label="Date Initiated"
        source="dDateInitiated"
        defaultValue=""
        variant="outlined"
      />,
      <DateInput
        label="Date Completed"
        source="dDateCompleted"
        defaultValue=""
        variant="outlined"
      />,
      <DateInput
        label="Date Failed"
        source="dDateFailed"
        defaultValue=""
        variant="outlined"
        disabled={
          newStatus == "repayment_past45initiatedButFailed" ||
          newStatus == "repayment_past45unableInitiate" ||
          newStatus == "repayment_past30initiatedButFailed" ||
          newStatus == "repayment_past30unableInitiate"
            ? false
            : true
        }
      />,
    ];

    setAchFilterData(AchPaymentsFilters);
  };

  return (
    <List
      actions={<AchPaymentsListActions />}
      filters={achFilterData}
      sort={{ field: "id", order: "DESC" }}
      aside={
        <AchPaymentsAside
          totalData={total}
          onChange={handleFilterStatusChange}
        />
      }
      exporter={customACHExporter}
      pagination={<PostPagination />}
      perPage={25}
      sx={{
        width: "100%",
        borderRadius: "0px",
        "& .MuiCard-root": {
          borderRadius: "0px",
        },
      }}
      empty={
        <Typography className="no-results">
          <NoResults />
        </Typography>
      }
      emptyWhileLoading={false}
      loading={<HmLoading />}
    >
      <DefaultList />
      {/* <ShowListTotal /> */}
    </List>
  );
};
const CustomCompletedField = ({ ...props }) => {
  const record = useRecordContext();
  if (!record) return null;
  if (record.dCompletedDate) {
    return <DateField source="dCompletedDate" />;
  } else {
    return (
      <Typography color="error">
        {record.sErrorMsg ? record.sErrorMsg : "No Completed Date"}
      </Typography>
    );
  }
};

const CustomMethodField = ({ ...props }) => {
  const record = useRecordContext();
  if (!record) return null;
  if (record?.sStatus == "cancelled") {
    return record?.sOwner;
  }
  const method = record?.scheduledBy;
  return <Typography>{getMetholdTitle(method)}</Typography>;
};
function getMetholdTitle(method: string) {
  if (method == "" || method == null || method == undefined) {
    return "";
  } else {
    return method;
  }
}
const DefaultList = ({ ...props }) => {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const listContext = useListContext();
  const { filterValues } = listContext;
  const { total, data, isPending, isLoading, isFetching } = useListContext();
  if (isPending)
    return (
      <Typography sx={{ p: 5 }} className="hm-list-datagrid">
        pending...
      </Typography>
    );
  if (isFetching)
    return (
      <Typography sx={{ p: 5 }} className="hm-list-datagrid">
        loading ...
      </Typography>
    );
  if (!total || total === 0) {
    return (
      <Typography sx={{ p: 5 }} className="hm-list-datagrid no-results">
        <NoResults />
      </Typography>
    );
  }

  let IdTitle = "Transfer #";
  if (
    filterValues.status &&
    filterValues.status.includes("Repayment - Scheduled (5Days)")
  ) {
    IdTitle = "Payment #";
  }

  const CancelTaskAction = ({ ...props }) => {
    const record = useRecordContext();
    if (!record) return null;
    const refresh = useRefresh();
    const callbackRefresh = () => {
      refresh();
    };
    // return record?.id;

    return (
      <CustomCancelTaskIcon
        type={record?.sType}
        id={record?.id}
        paymentId={record?.iPaymentId}
        onClick={callbackRefresh}
      />
    );
  };

  const CustomButton = ({ ...props }) => {
    let record = useRecordContext();
    if (!record) return null;
    const filterStatus = props.filterStatus;
    const { successNotify, errorNotify, infoNotify } = useNotify();
    const refresh = useRefresh();
    const handleShowTransferDetail = () => {
      // Update the record status in the database
      var reqUrl = "transfer/action/detail";
      var response = sendRequest(reqUrl, {
        id: record.id,
        data: {
          filterStatus: filterStatus,
        },
      });
      response
        .then((res) => {
          if (res.code == 200) {
            successNotify("Status changed successfully");
          } else {
            errorNotify("Failed to change status! " + res.message);
          }
        })
        .catch((error) => {
          errorNotify("Error changing status: " + error.message);
        });
    };
    const color = "red";
    const size = "22px";
    const fileSrc = "/public/icon/action-delete.svg";

    return (
      <>
        {record?.offline_refund == "offline" ? (
          <></>
        ) : (
          <AchPaymentsDetail filterStatus={filterStatus} record={record} />
        )}

        {filterStatus && filterStatus.includes("repayment_delayedFails") && (
          <ExceptionManualProcessed
            filterStatus={filterStatus}
            record={record}
          />
        )}
        {/* Payment scheduled today can be cancelled by 3:00 pm EST */}

        {filterStatus &&
          filterStatus.includes("today") &&
          (() => {
            const now = new Date();
            const estTime = new Date().toLocaleString("en-US", {
              timeZone: "America/New_York",
            });
            const estHours = new Date(estTime).getHours();
            const estMinutes = new Date(estTime).getMinutes();

            // 3:00 PM EST = 15:00
            const cancelDeadline = 15; // 15:00
            const currentHourDecimal = estHours + estMinutes / 60;

            //check if current time is before 3:00 PM EST
            const isBeforeDeadline = currentHourDecimal < cancelDeadline;

            return isBeforeDeadline ? (
              <CancelTaskAction
                lable="Action"
                source="action"
                sortable={false}
              />
            ) : null;
          })()}
      </>
    );
  };

  return (
    <>
      <Datagrid
        rowClick={false}
        optimized
        id="table-achpayments"
        className="hm-list-datagrid"
        empty={false}
        sx={{
          ".MuiTableCell-root": {
            padding: "6px",
          },
          ".RaDatagrid-headerCell:first-child": {
            borderTopLeftRadius: "0px",
          },
          ".RaDatagrid-headerCell:last-child": {
            borderTopRightRadius: "0px",
          },
          "& .column-groups": {
            md: { display: "none" },
            lg: { display: "table-cell" },
          },
          "& .Mui-active": {
            color: "gray",
          },
          "& .MuiTableSortLabel-root": {
            padding: "5px",
          },
          "& .RaDatagrid-headerCell": {
            color: "gray",
            fontSize: "1rem",
            backgroundColor: "#edf4fb",
            wordWrap: "break-word",
            whiteSpace: "pre-line",
          },
          "& .MuiTableCell-paddingCheckbox": {
            display: "none",
          },
          "& .MuiTableCell-root.column-id": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
          },
          "& .MuiTableCell-root.column-sErrorMsg": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
          },
          "& .MuiTableCell-root.column-dCreatedDate": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
          },
          "& .MuiTableCell-root.column-scheduled": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
          },
          "& .MuiTableCell-root.column-dSubmittedDate": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
          },
          "& .MuiTableCell-root.column-dCompletedDate": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
          },
          "& .MuiTableCell-root.column-dErrorDate": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
          },
          "& .MuiTableCell-root.column-dAmount": {
            textAlign: "right",
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdAmountWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdAmountWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdAmountWidth,
          },
          "& .MuiTableCell-root.column-iApplicationId": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdAppIdWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdAppIdWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdAppIdWidth,
          },
          "& .MuiTableCell-root.column-sLoanNum": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdLoanIdWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdLoanIdWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdLoanIdWidth,
          },
          "& .MuiTableCell-root.column-iUserId": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdUserIdWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdUserIdWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdUserIdWidth,
          },

          "& .MuiTableCell-root.column-sendbank": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            wordBreak: "break-word",
            overflowX: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
          },
          "& .MuiTableCell-root.column-sendaccount": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            wordBreak: "break-word",
            overflowX: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
          },
          "& .MuiTableCell-root.column-receivingbank": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            wordBreak: "break-word",
            overflowX: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
          },
          "& .MuiTableCell-root.column-receivingaccount": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            wordBreak: "break-word",
            overflowX: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
          },
          "& .MuiTableCell-root.column-sOwner": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            wordBreak: "break-word",
            overflowX: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
          },
        }}
        //   bulkActionButtons={<BankerBulkActions />}
      >
        {filterValues.status && filterValues.status.includes("today") ? (
          <TextField
            source="iSourceId"
            label={IdTitle}
            sortBy={"iSourceId"}
            cellClassName="numericText"
          />
        ) : (
          <TextField source="id" label={IdTitle} cellClassName="numericText" />
        )}
        {/* {filterValues?.status == "repayment_delayedFails" && (
          <TextField source="sType" label="Type" sortable={false} />
        )} */}
        <CustomAmountField
          source="dAmount"
          label="Amount"
          sortBy={"amount"}
          cellClassName="amountText"
        />
        {!/^refill_/i.test(filterValues.status) && (
          <ApplicationLinkApplicationIdField
            source="iApplicationId"
            label="App #"
            sortBy={"iApplicationId"}
          />
        )}
        {!/^refill_/i.test(filterValues.status) && (
          <LoanNumLinkField
            source="sLoanNum"
            label="Loan #"
            sortBy="sLoanNum"
          />
        )}
        {!/^refill_/i.test(filterValues.status) && (
          <CustomerIdLinkUserIdField
            source="iUserId"
            label="User #"
            sortBy={"iUserId"}
          />
        )}
        {/^repayment_/i.test(filterValues.status) && (
          <CustomMethodField
            source="sOwner"
            label="Method"
            sortable={false}
            cellClassName="textText"
          />
        )}

        {filterValues.status && (
          <CustomDateField
            source="scheduled"
            label="Date Scheduled"
            onlyShowDate={true}
            sortBy={"scheduled"}
            // sortable={false}
            cellClassName="dateText"
          />
        )}
        {/^(disbursement_|refund_)/i.test(filterValues.status) && (
          <CustomMethodField
            source="scheduledBy"
            label="Scheduled By"
            sortable={false}
            cellClassName="textText"
          />
        )}
        {filterValues.status && filterValues.status.includes("120-Day") && (
          <TextField source="sType" label="Type" sortable={false} />
        )}
        {filterValues.status && filterValues.status.includes("refill") && (
          <CustomDateField
            source="dCreatedDate"
            // label="Date Submitted"
            label="Date Initiated"
            onlyShowDate={true}
            sortBy={"submitted"}
            sortable={false}
            cellClassName="dateText"
          />
        )}

        {filterValues.status &&
          !filterValues.status.includes("refill") &&
          !filterValues.status.includes("Schedule") && (
            <CustomDateField
              source="dSubmittedDate"
              // label="Date Submitted"
              label="Date Initiated"
              onlyShowDate={true}
              sortBy={"dSubmittedDate"}
              // sortable={false}
              cellClassName="dateText"
            />
          )}
        {filterValues.status &&
          (filterValues.status.includes("past45processed") ||
            filterValues.status.includes("past30processed")) && (
            <CustomDateField
              source="dCompletedDate"
              label="Date Completed"
              onlyShowDate={true}
              sortBy={"dCompletedDate"}
              // sortable={false}
              cellClassName="dateText"
            />
          )}
        {filterValues.status &&
          (filterValues.status.includes("Failed") ||
            filterValues.status.includes("failed") ||
            filterValues.status.includes(
              "repayment_past45initiatedButFailed"
            ) ||
            filterValues.status.includes(
              "repayment_past30initiatedButFailed"
            ) ||
            filterValues.status.includes("Unable to Initiate") ||
            filterValues.status.includes("repayment_past45unableInitiate") ||
            filterValues.status.includes("repayment_past30unableInitiate") ||
            filterValues.status.includes("repayment_delayedFails") ||
            filterValues.status.includes("repayment_delayedCanceled") ||
            filterValues.status.includes("120-Day")) && (
            <CustomErrorMsg
              source="sErrorMsg"
              label="Error Code"
              sortable={false}
            />
          )}

        {filterValues.status &&
          (filterValues.status.includes("Failed") ||
            filterValues.status.includes("failed") ||
            filterValues.status.includes(
              "repayment_past45initiatedButFailed"
            ) ||
            filterValues.status.includes(
              "repayment_past30initiatedButFailed"
            ) ||
            filterValues.status.includes("Unable to Initiate") ||
            filterValues.status.includes("repayment_past45unableInitiate") ||
            filterValues.status.includes("repayment_past30unableInitiate") ||
            filterValues.status.includes("repayment_delayedFails") ||
            filterValues.status.includes("repayment_delayedCanceled") ||
            filterValues.status.includes("120-Day")) && (
            <CustomDateField
              source="dErrorDate"
              label="Date Failed"
              onlyShowDate={true}
              sortBy={false}
              sortable={false}
              cellClassName="dateText"
            />
          )}

        <CustomButton
          source="column-action"
          label={
            filterValues.status.includes("repayment_today")
              ? "Action"
              : "Detail"
          }
          filterStatus={filterValues.status}
          sortable={false}
        />
      </Datagrid>
      <CustomLoading />
    </>
  );
};
export default AchPaymentsList;
